// extracted by mini-css-extract-plugin
module.exports = {"pinkHeader":"HomepageCarousel_pinkHeader__fBqS0","greenRectangle":"HomepageCarousel_greenRectangle__X_jL5","subheading":"HomepageCarousel_subheading__05HBl"};